// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-trigger/~/rc-animate/lib/index.js
 ** module id = 230
 ** module chunks = 0
 **/